import { createSelector } from "reselect"
import { initialState } from "./reducer"

const selectReportAmbassadorV2Domain = (state) =>
  state.get("reportAmbassadorV2", initialState)

export const makeSelectIsLoading = () =>
  createSelector(selectReportAmbassadorV2Domain, (state) =>
    state.get("isLoading")
  )

export const makeSelectIsMeasureProcess = () =>
  createSelector(selectReportAmbassadorV2Domain, (state) =>
    state.get("isMeasureProcess")
  )

export const makeSelectDimensionsBottom = () =>
  createSelector(selectReportAmbassadorV2Domain, (state) =>
    state.get("dimensionsBottom")
  )

export const makeSelectDimensionsTop = () =>
  createSelector(selectReportAmbassadorV2Domain, (state) =>
    state.get("dimensionsTop")
  )

export const makeSelectDivisionsAvailable = () =>
  createSelector(selectReportAmbassadorV2Domain, (state) =>
    state.get("divisionsAvailable")
  )

export const makeSelectDivisionsData = () =>
  createSelector(selectReportAmbassadorV2Domain, (state) =>
    state.get("divisionsData")
  )

export const makeSelectMeasureGeneral = () =>
  createSelector(selectReportAmbassadorV2Domain, (state) =>
    state.get("measureGeneral")
  )

export const makeSelectMeasureTotal = () =>
  createSelector(selectReportAmbassadorV2Domain, (state) =>
    state.get("measureTotal")
  )

export const makeSelectIsErrorStatus = () =>
  createSelector(selectReportAmbassadorV2Domain, (state) =>
    state.get("isErrorStatus")
  )

export const makeSelectMeasureColorRange = () =>
  createSelector(selectReportAmbassadorV2Domain, (state) =>
    state.get("measureColorRange")
  )

export const makeSelectTypeMeasurement = () =>
  createSelector(selectReportAmbassadorV2Domain, (state) =>
    state.get("typeMeasurement")
  )

export const makeSelectIsLoadingTab = () =>
  createSelector(selectReportAmbassadorV2Domain, (state) =>
    state.get("isLoadingTab")
  )

export const makeSelectIsLoadingSubDivision = () =>
  createSelector(selectReportAmbassadorV2Domain, (state) =>
    state.get("isLoadingSubDivision")
  )

export const makeSelectMeasureInfo = () =>
  createSelector(selectReportAmbassadorV2Domain, (state) =>
    state.get("measureInfo")
  )

export const makeSelectUserType = () =>
  createSelector(selectReportAmbassadorV2Domain, (state) =>
    state.get("userType")
  )

const makeSelectReportAmbassadorV2 = () =>
  createSelector(selectReportAmbassadorV2Domain, (substate) =>
    substate.toJS()
  )

export default makeSelectReportAmbassadorV2
export { selectReportAmbassadorV2Domain }
